import { QueryClient } from '@tanstack/react-query';

// Configure React Query for optimal 2G performance
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Data considered fresh for 1 minute - won't refetch
      staleTime: 60 * 1000,
      // Cache data for 10 minutes even after components unmount
      gcTime: 10 * 60 * 1000, // Previously called cacheTime
      // Retry failed requests with exponential backoff
      retry: 3,
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      // Don't refetch on window focus for slow networks
      refetchOnWindowFocus: false,
      // Keep showing stale data while refetching
      placeholderData: 'keepPreviousData',
    },
    mutations: {
      // Retry failed mutations
      retry: 2,
      retryDelay: 1000,
    },
  },
});

// Pre-configure query keys for consistency
export const queryKeys = {
  users: {
    all: ['users'],
    list: (filters) => ['users', 'list', filters],
    lite: (filters) => ['users', 'lite', filters],
    detail: (id) => ['users', 'detail', id],
  },
  dashboard: ['dashboard'],
  campStatus: (date) => ['campStatus', date],
  infants: {
    all: ['infants'],
    list: (params) => ['infants', 'list', params],
    byMsp: (mspId) => ['infants', 'byMsp', mspId],
  },
  staff: {
    all: ['staff'],
    list: (params) => ['staff', 'list', params],
    detail: (id) => ['staff', 'detail', id],
  },
  schedule: {
    all: ['schedule'],
    byHall: (hall, day) => ['schedule', hall, day],
  },
  accommodation: {
    rooms: ['accommodation', 'rooms'],
    stats: ['accommodation', 'stats'],
  },
};




